import { Injectable } from '@angular/core';
import { Cookie } from 'ng2-cookies';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../auth';
import { Globals } from '../globals';
import { Observable } from 'rxjs';

@Injectable()
export class CameraService {

  constructor(private http: HttpClient, private authService: AuthenticationService, private globals: Globals) { }

  /**
   * get folder structure from backend containing images
   */
  getFolders() : Observable<any> {
    this.authService.isAuthenticated();
    const url = this.authService.getApiUrl() + '/api/v1/cameraimages/images';
    let requestHeaders = new HttpHeaders()
      .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
      .set('Authorization', 'Bearer ' + Cookie.get('accessToken'));
    return this.http.get(url, {headers: requestHeaders, responseType: 'json'});
  }


}